SA.Env = {
    isLocal: !/dev|test|live/.test(window.env),
    isTestServer: /dev|test/.test(window.env),

    getServerEnv() {
        if (this.isLocal) {
            return Ext.util.Cookies.get('sa_proxy_env') || 'dev';
        }

        return window.env;
    },

    isLive() {
        return window.env === 'live';
    }
};